import { useState as useState_ } from 'react'
import { useState as useStateStorybook } from 'storybook/preview-api'

// useState imported from react will fail in Storybook stories
// IS_STORYBOOK is added in .storybook/preview.js
// see also https://github.com/storybookjs/storybook/issues/29189
const useState = window?.IS_STORYBOOK ? useStateStorybook : useState_

export function useExpandablePageSection () {
  const [isFormVisible, setIsFormVisible] = useState(false)
  const [isExpanded, setIsExpanded] = useState(true)

  const toggleForm = () => {
    if (!isFormVisible && !isExpanded) {
      toggleExpanded()
    }
    setIsFormVisible(!isFormVisible)
  }

  const toggleExpanded = () => {
    if (isExpanded && isFormVisible) {
      toggleForm()
    }
    setIsExpanded(!isExpanded)
  }

  return ({
    isFormVisible,
    setIsFormVisible,
    isExpanded,
    setIsExpanded,
    toggleForm,
    toggleExpanded,
  })
}
